module.exports = __webpack_public_path__ + "img/4aca0df.jpg";